/**
 * Helper unificado de tracking — dispara eventos a PostHog y Google Analytics
 * SIEMPRE Y SOLO si el usuario otorgó consentimiento "analiticas".
 *
 * Si no hay consentimiento: no-op silencioso (no rompe, no acumula).
 *
 * Eventos principales del funnel:
 *   - scan_started: usuario envía URL al escáner
 *   - scan_completed: escáner devuelve resultado
 *   - lead_captured: usuario entrega email para desbloquear el reporte
 *   - signup_completed: cuenta creada
 *   - login_completed: usuario se autentica
 *   - modulo_pro_view: vista de /modulo-pro
 *   - checkout_initiated: click en "Activar Pro" (genera link MP)
 *   - checkout_completed: vuelve con ?pago=exito Y user.es_pro confirmado
 *   - document_generated: doc generado por backend
 *   - document_downloaded: usuario descarga PDF
 *
 * Uso:
 *   import { trackEvent } from "@/lib/analytics";
 *   trackEvent("scan_started", { domain: "example.cl" });
 */
import { getConsent } from "@/lib/cookieConsent";

function consentAllowed() {
  return !!getConsent()?.analiticas;
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (!consentAllowed()) return; // no-op si no consintieron

  // Google Analytics (gtag.js)
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch {
    // ignore
  }

  // PostHog
  try {
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(name, params);
    }
  } catch {
    // ignore
  }
}

export function trackPageview(path) {
  if (typeof window === "undefined") return;
  if (!consentAllowed()) return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  } catch {
    // ignore
  }
  // PostHog captura pageviews automáticamente cuando se inicializa.
}

// Helper para extraer dominio limpio (no sensible) de una URL
export function domainOf(url) {
  try {
    const u = new URL(url.startsWith("http") ? url : `https://${url}`);
    return u.hostname.replace(/^www\./, "");
  } catch {
    return "invalid";
  }
}
